import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StaffFrontDeskPanelAuthService {

  constructor() { }

  public isAuthenticated(): boolean {
    if(localStorage.getItem('hotelStaffUserData')){
      return true
    }
    return false
  };

  public isStaffUserLogin(): boolean {
    if(localStorage.getItem('isSignIn') === 'true' && localStorage.getItem('hotelStaffUserData')){
      return true
    }
    return false
  };
}
